import React, { useState } from 'react';
import { Plus, FolderPlus } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '../ui/dialog';
import { CategoryWithSubcategories } from '../custom/CategoryWithSubcategories';
import { menuAPI } from '../../utils/api';
import { toast } from 'sonner';

export const CategoryDialog = ({ categories, onUpdate }) => {
  const [open, setOpen] = useState(false);
  const [newCategoryName, setNewCategoryName] = useState('');

  const handleCreateCategory = async () => {
    if (!newCategoryName.trim()) {
      toast.error('Category name is required');
      return;
    }

    try {
      await menuAPI.createCategory(newCategoryName);
      toast.success('Category created successfully');
      setNewCategoryName('');
      onUpdate();
    } catch (error) {
      console.error('Failed to create category:', error);
      toast.error(error.response?.data?.detail || 'Failed to create category');
    }
  };

  return (
    <Dialog open={open} onOpenChange={(isOpen) => {
      setOpen(isOpen);
      if (isOpen) onUpdate();
    }}>
      <DialogTrigger asChild>
        <Button variant="outline" className="rounded-full">
          <FolderPlus className="h-4 w-4 mr-2" />
          Manage Categories
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Manage Categories & Subcategories</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <div className="flex gap-2">
            <Input
              placeholder="New category name"
              value={newCategoryName}
              onChange={(e) => setNewCategoryName(e.target.value)}
              onKeyPress={(e) => e.key === 'Enter' && handleCreateCategory()}
            />
            <Button onClick={handleCreateCategory}>
              <Plus className="h-4 w-4 mr-1" />
              Add Category
            </Button>
          </div>
          <p className="text-xs text-muted-foreground">Drag categories to reorder them</p>
          <div className="max-h-96 overflow-y-auto">
            {categories.length === 0 ? (
              <p className="text-sm text-muted-foreground text-center py-8">No categories yet</p>
            ) : (
              <CategoryWithSubcategories 
                categories={categories}
                onUpdate={onUpdate}
              />
            )}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
